module.exports = __webpack_public_path__ + "img/wuxue.7320735c.png";